import { iDevicePing } from "../../../shared/interfaces";

export enum ReplaySpeed {
    SLOW = 0.5,
    NORMAL = 1,
    FAST = 1.5,
    VERY_FAST = 2
}

export const SET_REPLAY_POINT = 'SET_REPLAY_POINT';
export const CLEAR_REPLAY_POINT = 'CLEAR_REPLAY_POINT';
export const SET_ACTIVE_DEVICE_ID = 'SET_ACTIVE_DEVICE_ID';
export const SET_REPLAY_SPEED = 'SET_REPLAY_SPEED';
export const SET_REPLAY_PLAYING = 'SET_REPLAY_PLAYING';
export const SET_ACTIVE_TRIP_ID = 'SET_ACTIVE_TRIP_ID';

export interface IReplayPoint {
    point: iDevicePing;
}

export const setReplayPoint = (payload: IReplayPoint) => ({
    type: SET_REPLAY_POINT as typeof SET_REPLAY_POINT,
    payload,
});

export const clearReplayPoint = () => ({
    type: CLEAR_REPLAY_POINT as typeof CLEAR_REPLAY_POINT,
});

export const setActiveDeviceId = (deviceId: string | null) => ({
    type: SET_ACTIVE_DEVICE_ID as typeof SET_ACTIVE_DEVICE_ID,
    payload: { deviceId },
});

export const setReplaySpeed = (speed: ReplaySpeed) => ({
    type: SET_REPLAY_SPEED as typeof SET_REPLAY_SPEED,
    payload: { speed },
});

export const setReplayPlaying = (deviceId: string, isPlaying: boolean) => ({
    type: SET_REPLAY_PLAYING as typeof SET_REPLAY_PLAYING,
    payload: { deviceId, isPlaying },
});

export const setActiveTripId = (tripId: string | null) => ({
    type: SET_ACTIVE_TRIP_ID as typeof SET_ACTIVE_TRIP_ID,
    payload: { tripId },
});

export type ReplayPointActions =
    | ReturnType<typeof setReplayPoint>
    | ReturnType<typeof clearReplayPoint>
    | ReturnType<typeof setActiveDeviceId>
    | ReturnType<typeof setReplaySpeed>
    | ReturnType<typeof setReplayPlaying>
    | ReturnType<typeof setActiveTripId>;